<template>
  <div>
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon name="arrow-left" class="mar_r" @click="goback" size="0.4rem" />
            <div class="search_con m_flex_box flex_vc">房贷预报名</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_top"></div>
    <van-field name="radio" label="房源类型:" class="cancelBorder">
      <template #input>
        <van-radio-group v-model="talentType" direction="horizontal">
          <van-radio name="Y">新房</van-radio>
          <van-radio name="N">二手房</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-form :scroll-to-error="true">
      <van-field v-model="name" type="text" label="申请人:" placeholder="请输入申请人" />
      <van-field v-model="phone" label="申请人手机号" placeholder="请输入申请人手机号" />
      <van-field readonly clickable name="picker" :value="bank" label="意向银行" placeholder="选择银行"
        @click="showBank = true" />
      <van-popup v-model="showBank" position="bottom">
        <van-picker show-toolbar :columns="bankArr" value-key="departName" @confirm="confirmBank"
          @cancel="showBank = false" />
      </van-popup>
      <div style="margin: 16px;font-size: 14px;color:#ccc">
        <p>温馨提示:</p>
        <p>
          1.尊敬的客户，为保护您的合法权益，您的贷款相关操作应由您本人操作，请勿将您的密码、验证码等个人信息及手机、电脑等个人设备提供给其他人员。
        </p>
        <p>
          2.如果您在徐房信息网预留的手机号不可用，可退出登录，进行手机号变更申请，变更申请通过后重新登录进行操作
        </p>
      </div>
      <div style="margin: 16px; padding-bottom: 16px">
        <van-button block type="info" :disabled="isDisabled" @click="submitData">提交</van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import topHeader from '@/components/header'
import qs from "qs";
export default {
  data() {
    return {
      isApp: this.$route.query.isApp || false,
      bank: "",
      bankId: '',
      showBank: false,
      bankArr: [],
      name: this.$route.query.name ? decodeURIComponent(this.$route.query.name) : "",
      phone: this.$route.query.phone || "",
      isDisabled: false,
      talentType: "Y",
      appToken: "",
      userId: ""
    };
  },
  components: {
    topHeader,
  },
  inject: ["judgeApp"],
  // created() {
  //   var ua = navigator.userAgent;
  //   var uaList = ua.split(" ");
  //   for (var i = 0; i < uaList.length; i++) {
  //     if (uaList[i].indexOf("token") > -1) {
  //       this.appToken = uaList[i].split("=")[1];
  //       break;
  //     }
  //   }
  // },
  mounted() {
    this.getUserInfo()
    this.bankInfo()
  },
  methods: {
    confirmBank(n) {
      this.bank = n.departName;
      this.bankId = n.orgCode
      this.showBank = false
    },
    bankInfo() {
      this.$request.post("erpService/yw/api/common/orgInfo", qs.stringify({
        "type": '5'
      })
      )
        .then((res) => {
          if (res.success) {
            this.bankArr = res.result[0].children
            this.bank = this.bankArr[0].departName
            this.bankId = this.bankArr[0].orgCode
          } else {
            this.$toast(res.message);
          }
        });
    },
    getUserInfo() {
      var that = this
      this.$http({
        url: 'cms/onlineUser/reg/getOnlineUser.do',
        method: 'POST',
      }).then(res => {
        if (res.success) {
          this.name = res.obj.realName
          this.phone = res.obj.phone
          this.userId = res.obj.id
        } else {
          this.$toast(res.message);
        }
      })
    },
    submitData() {
      this.$request.post("erpService/yw/api/customer/saveLoan", qs.stringify({
        "houseType": this.talentType,
        "name": this.name,
        "phone": this.phone,
        'orgCode': this.bankId
      })
      )
        .then((res) => {
          if (res.success) {
            this.$toast(res.message);
          } else {
            this.$toast(res.message);
          }
        });
    },
    goback() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;

  .top_normal {
    height: 100%;

    i {
      font-size: 0.32rem;
    }
  }
}

.fixed_top {
  padding-top: 1.1rem;
}

.top_header {
  height: 0.7rem;
  padding: 0.1rem 0rem;
  width: 7.04rem;
  margin: 0 auto;

  &.top_sm {
    padding: 0.1rem;
  }

  .search_con,
  .search_con_l {
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    padding: 0 0.3rem;
    color: #303030;

    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }

  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }

  .search_con {
    font-weight: bolder;
    justify-content: center;
    width: 5.78rem;
  }

  .search_con_l {
    width: 5.72rem;
  }

  .to_map {
    font-size: 0.28rem;

    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
</style>